<template>
  <div class="product-second">
    <ul class="product-grade">
      <li class="product-grade-cell" v-for="(item, index) in gradeList" :key="'grade-' + index">
        <span>{{ item.level }}</span>
        <span :style="index == 0 && screenWidth <= 500 ?'line-height:23px':''">{{ item.goldDiscount }}</span>
        <span :style="index == 0 && screenWidth <= 500 ? 'line-height:23px' : ''">{{ item.silverDiscount }}</span>
        <span>{{ item.points }}</span>
      </li>
    </ul>
    <ul class="grade-describe">
      <li>账户级别说明：</li>
      <li>1. 开户后，每位用户起点一样，用户起始账户级别为1级，最高可升级至30级，每升一级，可享受更高的点差优惠；</li>
      <li>2. 用户可通过赚取积分，升级账户级别，获取更多点差优惠，从而减少交易成本，最高可达0成本交易；</li>
      <!-- <li>3. 层级只升不降，近期无交易打算，也不会有降级风险，本公司会为您保留账户层级；</li> -->
      <li>3. 有关账户升级详细内容，欢迎下载app查阅；</li>
      <li>4. 本公司对此优惠保留最终解释权。</li>
    </ul>
  </div>
</template>

<script>
export default {
  
  data() {
    return {

      gradeList: [
        { level: '账户级别', goldDiscount: '伦敦金点差优惠', silverDiscount: '伦敦银点差优惠', points: '升级所需积分' },
        { level: 'L1', goldDiscount: '$20/手', silverDiscount: '$75/手', points: 0 },
        { level: 'L2', goldDiscount: '$21/手', silverDiscount: '$76/手', points: 1000 },
        { level: 'L3', goldDiscount: '$22/手', silverDiscount: '$77/手', points: 5000 },
        { level: 'L4', goldDiscount: '$23/手', silverDiscount: '$78/手', points: 10000 },
        { level: 'L5', goldDiscount: '$24/手', silverDiscount: '$79/手', points: 20000 },
        { level: 'L6', goldDiscount: '$25/手', silverDiscount: '$80/手', points: 40000 },
        { level: 'L7', goldDiscount: '$26/手', silverDiscount: '$81/手', points: 60000 },
        { level: '...', goldDiscount: '/', silverDiscount: '/', points: '/' },
        { level: 'L30', goldDiscount: '$49/手', silverDiscount: '$104/手', points: '...' },
      ],
      screenWidth: document.body.clientWidth,//实时屏幕宽度

    }
  }
}
</script>

<style lang="less" scoped>
  .product-second{
    
    .product-grade {
      background: #FFFFFF;
      margin-bottom: 50px;

      &-cell {
        display: flex;
        text-align: center;
        line-height: 76px;
        border-bottom: 1px solid #EBEEF5;

        span {
          border-right: 1px solid #EBEEF5;
          &:first-child {
            width: 186px;
          }

          &:nth-child(2) {
            width: 292px;
          }

          &:nth-child(3) {
                        width: 292px;
          }

          &:nth-child(4) {
            flex: 1;
            border: none;
            color: #FA2314;
          }
        }
        &:first-child {
          background: linear-gradient(to right, #FA2314, #DB2C23);
          color: #FFFFFF;
          font-size: 20px;
          font-weight: 600;

          span {
            border: none;
            &:nth-child(4) {
              background: url('../../../../assets/imgs/intro-title-bg.png') no-repeat;
              background-size: 100% 100%;
              color: #FFFFFF;
            }
          }
        }
      }
    }

    .grade-describe {
      margin-bottom: 50px;
      li {
        line-height: 40px;
        color: #93939F;
        &:first-child {
          font-size: 18px;
          color: #000;
        }
      }
    }
  }
  @media screen and (max-width: 500px) {
    .product-second{
      margin:0 16px;
    .product-grade {
      &-cell {
        line-height:46px;
        font-size:12px;

         span {
          &:first-child {
            width: 101px;
          }

          &:nth-child(2) {
            width: 70px;
    
          }
                    &:nth-child(3) {
                      width: 70px;
   

                    }
        }
        &:first-child {
          font-size:12px;
        }
      }
    }
    .grade-describe {
    
      li {
        line-height: 20px;
        font-size:12px;

        color: #93939F;
          font-size: 12px;

        &:first-child {
          font-size: 12px;
          color: #000;
        }
      }
    }
    }
  }
</style>